import React from 'react';

export default function ProductSearch({ name, value, placeholder, columns, handleInput, onChange }) {
    return (
        <input
            type="text"
            data-columns={columns}
            name={name}
            placeholder={placeholder}
            value={value} 
            onInput={(e) => handleInput(e)} 
            onChange={onChange} 
            aria-labelledby="search"
        />
    );
}
